module.exports = __webpack_public_path__ + "static/media/5.eb63da4d.svg";